import Environment from '../../Environment';
import stages from '../stages';
import MockSplit from '../../MockSplit';
import Region from '../../../constants/region';

const prod = new Environment({
    name: stages.PRODUCTION,
    evaluationFn: (_attributes) => {
        return 'off';
    },
});

const demo = new Environment({
    name: stages.DEMO,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const staging = new Environment({
    name: stages.STAGING,
    regions: [Region.CDI],
});

const local = new Environment({
    name: stages.LOCAL,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const dev = new Environment({
    name: stages.DEV,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const can_access_schedule_automatch_demo_mode = new MockSplit({
    name: 'can_access_schedule_automatch_demo_mode',
    environments: [local, dev, staging, demo, prod],
});

export default can_access_schedule_automatch_demo_mode;
